var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copied-successfully",class:_vm.isCopy ? 'active' : ''},[_vm._v(" "+_vm._s(_vm.$t('generalTabs.linkHasBeenCopied'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }